import { FILTER } from "../../actions/portal";

export default function(state = true, action) {
  switch (action.type) {
    case FILTER:
      return action.payload;
    default:
  }

  return state;
}
